/** W3C trace-context ids (lower-case hex, never all zero). */
function randomHex(bytes: number): string {
  const buf = new Uint8Array(bytes);
  crypto.getRandomValues(buf);
  let out = '';
  for (const b of buf) out += b.toString(16).padStart(2, '0');
  return /^0+$/.test(out) ? randomHex(bytes) : out;
}

export const newTraceId = (): string => randomHex(16);
export const newSpanId = (): string => randomHex(8);

export function traceparent(traceId: string, spanId: string): string {
  return `00-${traceId}-${spanId}-01`;
}

/** `00-<trace>-<span>-<flags>` → ids, or null. */
export function parseTraceparent(tp: unknown): { traceId: string; spanId: string } | null {
  if (typeof tp !== 'string') return null;
  const m = /^00-([0-9a-f]{32})-([0-9a-f]{16})-[0-9a-f]{2}$/.exec(tp);
  return m ? { traceId: m[1]!, spanId: m[2]! } : null;
}

export function uuid(): string {
  if (typeof crypto.randomUUID === 'function') return crypto.randomUUID();
  const h = randomHex(16);
  return `${h.slice(0, 8)}-${h.slice(8, 12)}-4${h.slice(13, 16)}-a${h.slice(17, 20)}-${h.slice(20, 32)}`;
}
